import MutedText from '../common/MutedText';
import { Button } from '@athena/forge';
import { getLocalizedString } from '../../utils/i18n-utils';

export interface SecretKeyInstructionsProps {
  container: JQuery<HTMLElement>;
}

export default function SecretKeyInstructions({ container }: SecretKeyInstructionsProps) {
  const sharedSecret = container.find('.shared-secret').find('input')
    .attr('placeholder');
  const text = container.find('.oie-enroll-google-authenticator-manual-setup .google-authenticator-setup-info').text();
  if (text && sharedSecret) {
    return (
      <div className="fe_u_text-align--center">
        <MutedText text={text} />
        <p className="fe_u_font-size--large text-wrap-anywhere">
          {sharedSecret}
        </p>
        <Button
          text={getLocalizedString('mfa.athena.scanBarcode')}
          onClick={() => {
            oktaSignIn.router.controller.formView.model.set('viewToDisplay', 'barcode');
          }}
          variant="tertiary"
        ></Button>
      </div>
    );
  }
  else {
    return <></>;
  }
}
